import { render } from "./SidebarPage.vue?vue&type=template&id=078489d2&scoped=true"
import script from "./SidebarPage.vue?vue&type=script&lang=js"
export * from "./SidebarPage.vue?vue&type=script&lang=js"

import "./SidebarPage.vue?vue&type=style&index=0&id=078489d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078489d2"]])

export default __exports__